import ApiService from './ApiService'

export async function apiGetSalesDashboardData(data) {
    return ApiService.fetchData({
        url: '/admin/dashboard/sales',
        method: 'post',
        data,
    })
}

export async function apiGetAbandonedCarts() {
    return ApiService.fetchData({
        url: '/admin/dashboard/abandoned-carts',
        method: 'get',
    })
}

// New dashboard API endpoints
export async function apiGetDashboardSalesData(data) {
    return ApiService.fetchData({
        url: '/admin/dashboard/sales',
        method: 'post',
        data,
    })
}

export async function apiGetDashboardStatistics(params) {
    return ApiService.fetchData({
        url: '/admin/dashboard/statistics',
        method: 'get',
        params,
    })
}

export async function apiGetTopSellingProducts(params) {
    return ApiService.fetchData({
        url: '/admin/dashboard/top-products',
        method: 'get',
        params,
    })
}

export async function apiGetSalesByCategories(params) {
    return ApiService.fetchData({
        url: '/admin/dashboard/sales-by-categories',
        method: 'get',
        params,
    })
}
export async function apiGetSalesReportData(data) {
    return ApiService.fetchData({
        url: '/admin/dashboard/sales',
        method: 'post',
        data,
    })
}

// Support API endpoints
export async function apiGetSupport(params) {
    return ApiService.fetchData({
        url: '/support/list',
        method: 'get',
        params,
    })
}

export async function apiGetSupportById(id) {
    return ApiService.fetchData({
        url: `/support/${id}`,
        method: 'get',
    })
}

export async function apiUpdateSupport(id, data) {
    return ApiService.fetchData({
        url: `/support/${id}`,
        method: 'put',
        data,
    })
}

export async function apiDeleteSupport(id) {
    return ApiService.fetchData({
        url: `/support/${id}`,
        method: 'delete',
    })
}

export async function apiGetSupportStats() {
    return ApiService.fetchData({
        url: '/support/stats',
        method: 'get',
    })
}

export async function apiReplyToSupport(id, data) {
    return ApiService.fetchData({
        url: `/support/${id}/reply`,
        method: 'post',
        data,
    })
}


// ======================
// OFFERS API (Admin)
// ======================
export async function apiGetAllOffers(params) {
    return ApiService.fetchData({
        url: '/offers/admin/all',
        method: 'get',
        params,
    })
}

export async function getPaymentStatus(data) {
    return ApiService.fetchData({
        url: '/cart/paymentStatus',
        method: 'post',
        data,
    })
}

export async function updatePaymentStatus(data) {
    console.log('🔍 updatePaymentStatus function called with data:', data)
    console.log('🔍 Making API call to /orders/payment/update')

    return ApiService.fetchData({
        url: '/orders/payment/update',
        method: 'put',
        data,
    })
}

export async function getOrderDetails(data) {
    return ApiService.fetchData({
        url: `/order/status`,
        method: 'post',
        data,
    })
}

// ======================
// CATEGORIES API
// ======================
export async function apiGetCategories(data) {
    return ApiService.fetchData({
        url: '/categories',
        method: 'get',
        params: data,
    })
}

export async function apiGetCategoryUsage() {
    return ApiService.fetchData({
        url: '/categories/admin/usage',
        method: 'get',
    })
}

export async function apiGetSalesCategories(params) {
    return ApiService.fetchData({
        url: '/categories',
        method: 'get',
        params,
    })
}

export async function apiGetSalesCategoryById(id) {
    return ApiService.fetchData({
        url: `/categories/${id}`,
        method: 'get',
    })
}

export async function apiGetSalesCategoryBySlug(slug) {
    return ApiService.fetchData({
        url: `/categories/${slug}`,
        method: 'get',
    })
}

export async function apiPutSalesCategory(data) {
    console.log(data);
    return ApiService.fetchData({
        url: '/categories/update',
        method: 'put',
        data,
    })
}

export async function apiCreateSalesCategory(data) {
    return ApiService.fetchData({
        url: '/categories/create',
        method: 'post',
        data,
    })
}

export async function apiDeleteSalesCategories(data) {
    return ApiService.fetchData({
        url: '/categories/delete',
        method: 'delete',
        data,
    })
}

// ======================
// SUB-CATEGORIES API
// ======================
export async function apiGetSalesSubCategories(params) {
    return ApiService.fetchData({
        url: '/sub-categories',
        method: 'get',
        params,
    })
}

export async function apiGetSalesSubCategoriesForAdmin(params) {
    return ApiService.fetchData({
        url: '/sub-categories/admin/list',
        method: 'get',
        params,
    })
}

// NEW: Get subcategories by category slug
export async function apiGetSubCategoriesByCategory(categorySlug, params = {}) {
    return ApiService.fetchData({
        url: `/categories/${categorySlug}/sub-categories`,
        method: 'get',
        params,
    })
}

export async function apiGetSalesSubCategoryById(id) {
    return ApiService.fetchData({
        url: `/sub-categories/${id}`,
        method: 'get',
    })
}

export async function apiGetSalesSubCategoryBySlug(slug) {
    return ApiService.fetchData({
        url: `/sub-categories/${slug}`,
        method: 'get',
    })
}

export async function apiPutSalesSubCategory(data) {
    console.log(data);
    return ApiService.fetchData({
        url: '/sub-categories/update',
        method: 'put',
        data,
    })
}

export async function apiCreateSalesSubCategory(data) {
    return ApiService.fetchData({
        url: '/sub-categories/create',
        method: 'post',
        data,
    })
}

export async function apiDeleteSalesSubCategories(data) {
    return ApiService.fetchData({
        url: '/sub-categories/delete',
        method: 'delete',
        data,
    })
}

// ======================
// BANNERS API
// ======================
export async function apiGetBanners(params) {
    return ApiService.fetchData({
        url: '/banner/list',
        method: 'get',
        params,
    })
}

export async function apiGetBanner(slug) {
    return ApiService.fetchData({
        url: `/banner/${slug}`,
        method: 'get',
    })
}

export async function apiGetBannerById(id) {
    return ApiService.fetchData({
        url: `/banner/${id}`,
        method: 'get',
    })
}

export async function apiCreateBanner(data) {
    return ApiService.fetchData({
        url: '/banner/create',
        method: 'post',
        data,
    })
}

export async function apiUpdateBanner(data) {
    return ApiService.fetchData({
        url: '/banner/update',
        method: 'put',
        data,
    })
}

export async function apiDeleteBanner(data) {
    return ApiService.fetchData({
        url: '/banner/delete',
        method: 'delete',
        data,
    })
}

export async function apiDeleteBanners(data) {
    return ApiService.fetchData({
        url: '/banner/bulk-delete',
        method: 'delete',
        data,
    })
}

export async function apiRestoreBanner(data) {
    return ApiService.fetchData({
        url: '/banner/restore',
        method: 'post',
        data,
    })
}

// ======================
// Updated Sales Banner API (matching actual backend)
// ======================
export async function apiGetSalesBanner(params) {
    return ApiService.fetchData({
        url: '/banner/list',
        method: 'get',
        params,
    })
}

export async function apiGetSalesBannerById(id) {
    return ApiService.fetchData({
        url: `/banner/${id}`,
        method: 'get',
    })
}

export async function apiGetSalesBannerBySlug(slug) {
    return ApiService.fetchData({
        url: `/banner/${slug}`,
        method: 'get',
    })
}

export async function apiPutSalesBanner(data) {
    return ApiService.fetchData({
        url: '/banner/update',
        method: 'put',
        data,
    })
}

export async function apiCreateSalesBanner(data) {
    return ApiService.fetchData({
        url: '/banner/create',
        method: 'post',
        data,
    })
}

export async function apiDeleteSalesBanner(data) {
    return ApiService.fetchData({
        url: '/banner/delete',
        method: 'delete',
        data,
    })
}

// ======================
// Catalogue landing pages (brands → model families → models)
// ======================
export async function apiCatalogFamilies(params) {
    return ApiService.fetchData({ url: '/catalog/admin/families', method: 'get', params })
}
export async function apiCatalogSaveFamily(data, isNew) {
    return ApiService.fetchData({ url: '/catalog/admin/families', method: isNew ? 'post' : 'put', data })
}
export async function apiCatalogDeleteFamily(data) {
    return ApiService.fetchData({ url: '/catalog/admin/families', method: 'delete', data })
}
export async function apiCatalogModels(params) {
    return ApiService.fetchData({ url: '/catalog/admin/models', method: 'get', params })
}
export async function apiCatalogSaveModel(data, isNew) {
    return ApiService.fetchData({ url: '/catalog/admin/models', method: isNew ? 'post' : 'put', data })
}
export async function apiCatalogDeleteModel(data) {
    return ApiService.fetchData({ url: '/catalog/admin/models', method: 'delete', data })
}
export async function apiCatalogSuggestAssociations(modelId) {
    return ApiService.fetchData({ url: '/catalog/admin/suggest-associations', method: 'get', params: { model: modelId } })
}
export async function apiCatalogBulkAssign(data) {
    return ApiService.fetchData({ url: '/catalog/admin/bulk-assign', method: 'post', data })
}
export async function apiCatalogModelProducts(modelId, params = {}) {
    return ApiService.fetchData({ url: `/catalog/admin/models/${modelId}/products`, method: 'get', params })
}
export async function apiCatalogRedirects() {
    return ApiService.fetchData({ url: '/catalog/admin/redirects', method: 'get' })
}
export async function apiCatalogCreateRedirect(data) {
    return ApiService.fetchData({ url: '/catalog/admin/redirects', method: 'post', data })
}
export async function apiCatalogUpdateRedirect(data) {
    return ApiService.fetchData({ url: '/catalog/admin/redirects', method: 'put', data })
}

export async function apiRestoreSalesBanner(data) {
    return ApiService.fetchData({
        url: '/banner/restore',
        method: 'post',
        data,
    })
}

export async function apiGetBannerUsage(ids) {
    return ApiService.fetchData({
        url: '/banner/usage',
        method: 'get',
        params: { ids: (ids || []).join(',') },
    })
}

// ======================
// COLLECTIONS API
// ======================
export async function apiGetCollections(params) {
    return ApiService.fetchData({
        url: '/collection/list',
        method: 'get',
        params,
    })
}

export async function apiGetCollectionById(id) {
    return ApiService.fetchData({
        url: `/collection/${id}`,
        method: 'get',
    })
}

export async function apiPreviewSmartCollection(smartRules) {
    return ApiService.fetchData({
        url: '/collection/preview-smart',
        method: 'post',
        data: { smartRules },
    })
}

export async function apiCreateCollection(data) {
    return ApiService.fetchData({
        url: '/collection/create',
        method: 'post',
        data,
    })
}

export async function apiPutCollection(data) {
    return ApiService.fetchData({
        url: '/collection/update',
        method: 'put',
        data,
    })
}

export async function apiDeleteCollection(data) {
    return ApiService.fetchData({
        url: '/collection/delete',
        method: 'delete',
        data,
    })
}

// ======================
// PRODUCTS API
// ======================
export async function apiGetProductsSummary() {
    return ApiService.fetchData({
        url: '/product/admin/summary',
        method: 'get',
    })
}

export async function apiGetSalesProducts(params) {
    return ApiService.fetchData({
        url: '/product/list',
        method: 'get',
        params,
    })
}

export async function apiGetSalesProduct(params) {
    return ApiService.fetchData({
        url: '/product',
        method: 'get',
        params,
    })
}

export async function apiGetSalesProductById(id) {
    return ApiService.fetchData({
        url: `/product/${id}`,
        method: 'get',
    })
}

export async function apiDeleteSalesProducts(data) {
    return ApiService.fetchData({
        url: '/product/delete',
        method: 'delete',
        data,
    })
}

export async function apiPutSalesProduct(data) {
    return ApiService.fetchData({
        url: '/product/update',
        method: 'put',
        data,
    })
}

export async function apiAddSalesProduct(data) {
    return ApiService.fetchData({
        url: '/product/create',
        method: 'post',
        data,
    })
}

// New API endpoint for selling items with file upload support
export async function apiSellItem(data) {
    return ApiService.fetchData({
        url: '/product/sell',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

// Wear It Pro: admin opts a product into / out of the B2B catalog
export async function apiSetProductProAvailability(productId, availableOnPro) {
    return ApiService.fetchData({
        url: `/product/admin/${productId}/pro-availability`,
        method: 'patch',
        data: { availableOnPro },
    })
}

// NEW: Admin-specific product creation API
export async function apiCreateProductForAdmin(data) {
    return ApiService.fetchData({
        url: '/product/create-admin',
        method: 'post',
        data,
    })
}

// Attach a shipping label (PDF/image) for a supplier's order — emails it to them.
export async function apiUploadShippingLabel(orderId, formData) {
    return ApiService.fetchData({
        url: `/admin/fulfillment/label/${orderId}`,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
    })
}

// Record a supplier payout with proof of payment — emails the supplier.
export async function apiMarkOrderPaidOut(orderId, formData) {
    return ApiService.fetchData({
        url: `/admin/fulfillment/payout/${orderId}`,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
    })
}

// Enhanced product update API with file upload support
export async function apiUpdateSalesProduct(data) {
    // Check if data contains File objects (indicating file uploads)
    const hasFiles = data instanceof FormData ||
        (typeof data === 'object' && Object.values(data).some(value =>
            value instanceof File ||
            (Array.isArray(value) && value.some(item => item instanceof File))
        ));

    return ApiService.fetchData({
        url: '/product/update',
        method: 'put',
        data,
        ...(hasFiles && {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    })
}

// Get product by ID or slug
export async function apiGetProductByIdOrSlug(slug) {
    return ApiService.fetchData({
        url: `/product/${slug}`,
        method: 'get',
    })
}

// Add to favorites
export async function apiAddToFavorites(data) {
    return ApiService.fetchData({
        url: '/product/favorites/add',
        method: 'post',
        data,
    })
}

// Remove from favorites
export async function apiRemoveFromFavorites(data) {
    return ApiService.fetchData({
        url: '/product/favorites/remove',
        method: 'delete',
        data,
    })
}

// Get favorite products
export async function apiGetFavoriteProducts(params) {
    return ApiService.fetchData({
        url: '/product/favorites',
        method: 'get',
        params,
    })
}

// Add recent view
export async function apiAddRecentView(data) {
    return ApiService.fetchData({
        url: '/product/recent-views/add',
        method: 'post',
        data,
    })
}

// Get recent views
export async function apiGetRecentViews(params) {
    return ApiService.fetchData({
        url: '/product/recent-views/get',
        method: 'get',
        params,
    })
}

// Product comments API
export async function apiAddProductComment(data) {
    return ApiService.fetchData({
        url: '/product/comments/add',
        method: 'post',
        data,
    })
}

export async function apiGetProductComments(slug, params) {
    return ApiService.fetchData({
        url: `/product/${slug}/comments`,
        method: 'get',
        params,
    })
}

export async function apiReplyToComment(data) {
    return ApiService.fetchData({
        url: '/product/comments/reply',
        method: 'post',
        data,
    })
}

export async function apiLikeComment(data) {
    return ApiService.fetchData({
        url: '/product/comments/like',
        method: 'post',
        data,
    })
}

export async function apiDeleteComment(data) {
    return ApiService.fetchData({
        url: '/product/comments/delete',
        method: 'delete',
        data,
    })
}

export async function apiDeleteReply(data) {
    return ApiService.fetchData({
        url: '/product/comments/replies/delete',
        method: 'delete',
        data,
    })
}

// ======================
// ORDERS API
// ======================
export async function apiGetOrdersSummary() {
    return ApiService.fetchData({ url: '/orders/admin/summary', method: 'get' })
}

export async function apiAddOrderNote(orderId, note) {
    return ApiService.fetchData({ url: `/orders/admin/${orderId}/note`, method: 'post', data: { note } })
}

export async function apiGetSalesOrders(params) {
    return ApiService.fetchData({
        url: '/orders/admin/all',
        method: 'get',
        params,
    })
}

export async function apiGetSalesOrderDetails(id) {
    return ApiService.fetchData({
        url: `/orders/${id}`,
        method: 'get',
    })
}

export async function apiGetAdminOrderDetails(id) {
    return ApiService.fetchData({
        url: `/orders/admin/${id}`,
        method: 'get',
    })
}

// Re-send the buyer/seller/admin payment-success notifications for a paid order.
export async function apiResendOrderNotifications(id) {
    return ApiService.fetchData({
        url: `/orders/admin/${id}/resend-notifications`,
        method: 'post',
    })
}

export async function apiExportOrdersCSV(params) {
    return ApiService.fetchData({
        url: '/orders/admin/export-csv',
        method: 'get',
        params,
        responseType: 'blob',
    })
}

export async function apiDeleteSalesOrders(data) {
    return ApiService.fetchData({
        url: '/orders/admin/delete',
        method: 'delete',
        data,
    })
}

export async function apiUpdateOrderStatus(data) {
    return ApiService.fetchData({
        url: '/orders/status/update',
        method: 'put',
        data,
    })
}

// ======================
// BRANDS API
// ======================
export async function apiGetBrandUsage() {
    return ApiService.fetchData({
        url: '/brand/admin/usage',
        method: 'get',
    })
}

export async function apiGetBrands(params) {
    return ApiService.fetchData({
        url: '/brand/list',
        method: 'get',
        params,
    })
}

export async function apiGetBrand(slug) {
    return ApiService.fetchData({
        url: `/brand/${slug}`,
        method: 'get',
    })
}

export async function apiGetBrandById(slug) {
    return ApiService.fetchData({
        url: `/brand/${slug}`,
        method: 'get',
    })
}

export async function apiCreateBrand(data) {
    return ApiService.fetchData({
        url: '/brand/create',
        method: 'post',
        data,
    })
}

export async function apiUpdateBrand(id, data) {
    return ApiService.fetchData({
        url: '/brand/update',
        method: 'put',
        data: { id, ...data },
    })
}

export async function apiDeleteBrand(id) {
    return ApiService.fetchData({
        url: '/brand/delete',
        method: 'delete',
        data: { id },
    })
}

export async function apiDeleteBrands(data) {
    return ApiService.fetchData({
        url: '/brand/bulk-delete',
        method: 'delete',
        data,
    })
}

export async function apiGetBrandStatistics() {
    return ApiService.fetchData({
        url: '/brand/statistics',
        method: 'get',
    })
}

// ======================
// TAXONOMIES API
// ======================
export async function apiGetTaxonomies(params) {
    return ApiService.fetchData({
        url: '/taxonomies',
        method: 'get',
        params,
    })
}

export async function apiGetTaxonomyById(type, slug) {
    return ApiService.fetchData({
        url: `/taxonomies/${type}/${slug}`,
        method: 'get',
    })
}

export async function apiCreateTaxonomy(data, typeSlug) {
    return ApiService.fetchData({
        url: `/taxonomies/${typeSlug}/create`,
        method: 'post',
        data,
    })
}

export async function apiUpdateTaxonomy(id, data, typeSlug) {
    return ApiService.fetchData({
        url: `/taxonomies/${typeSlug}/update`,
        method: 'put',
        data: { id, ...data },
    })
}

export async function apiDeleteTaxonomy(id, typeSlug) {
    return ApiService.fetchData({
        url: `/taxonomies/${typeSlug}/delete`,
        method: 'post',
        data: { id },
    })
}

// ======================
// SELLING TYPES API
// ======================
export async function apiGetSellingTypes(params) {
    return ApiService.fetchData({
        url: '/selling-type/list',
        method: 'get',
        params,
    })
}

export async function apiGetSellingTypeById(id) {
    return ApiService.fetchData({
        url: `/selling-type/${id}`,
        method: 'get',
    })
}

export async function apiGetSellingTypeUsage() {
    return ApiService.fetchData({
        url: '/selling-type/admin/usage',
        method: 'get',
    })
}

export async function apiCreateSellingType(data) {
    return ApiService.fetchData({
        url: '/selling-type/create',
        method: 'post',
        data,
    })
}

export async function apiUpdateSellingType(id, data) {
    return ApiService.fetchData({
        url: '/selling-type/update',
        method: 'put',
        data: { id, ...data },
    })
}

export async function apiDeleteSellingType(id) {
    return ApiService.fetchData({
        url: '/selling-type/delete',
        method: 'delete',
        data: { id },
    })
}

// ======================
// LANGUAGES API
// ======================
export async function apiGetLanguages(params) {
    return ApiService.fetchData({
        url: '/language/list',
        method: 'get',
        params,
    })
}

export async function apiGetLanguageBySlug(slug) {
    return ApiService.fetchData({
        url: `/language/${slug}`,
        method: 'get',
    })
}

export async function apiCreateLanguage(data) {
    return ApiService.fetchData({
        url: '/language/create',
        method: 'post',
        data,
    })
}

export async function apiUpdateLanguage(data) {
    return ApiService.fetchData({
        url: '/language/update',
        method: 'put',
        data,
    })
}

export async function apiDeleteLanguage(data) {
    return ApiService.fetchData({
        url: '/language/delete',
        method: 'delete',
        data,
    })
}

// ======================
// FAQs API
// ======================
export async function apiGetFAQs(params) {
    return ApiService.fetchData({
        url: '/FAQ/list',
        method: 'get',
        params,
    })
}

export async function apiGetFAQById(id) {
    return ApiService.fetchData({
        url: `/FAQ/detail/${id}`,
        method: 'get',
    })
}

export async function apiCreateFAQ(data) {
    return ApiService.fetchData({
        url: '/FAQ/create',
        method: 'post',
        data,
    })
}

export async function apiUpdateFAQ(id, data) {
    return ApiService.fetchData({
        url: '/FAQ/update',
        method: 'put',
        data: { id, ...data },
    })
}

export async function apiDeleteFAQ(id) {
    return ApiService.fetchData({
        url: '/FAQ/delete',
        method: 'delete',
        data: { id },
    })
}

// ======================
// OFFERS API
// ======================
export async function apiGetOffers(params) {
    return ApiService.fetchData({
        url: '/offers',
        method: 'get',
        params,
    })
}

export async function apiGetOfferById(id) {
    return ApiService.fetchData({
        url: `/offers/${id}`,
        method: 'get',
    })
}

export async function apiCreateOffer(data) {
    return ApiService.fetchData({
        url: '/offers',
        method: 'post',
        data,
    })
}

export async function apiUpdateOffer(id, data) {
    return ApiService.fetchData({
        url: `/offers/${id}`,
        method: 'put',
        data,
    })
}

export async function apiAdminUpdateOffer(data) {
    return ApiService.fetchData({
        url: '/offers/admin/update',
        method: 'put',
        data,
    })
}

export async function apiDeleteOffer(id) {
    return ApiService.fetchData({
        url: `/offers/admin/${id}`,
        method: 'delete',
    })
}

// ======================
// CHATS API
// ======================
export async function apiGetChats(params) {
    return ApiService.fetchData({
        url: '/chats',
        method: 'get',
        params,
    })
}

export async function apiGetChatById(id) {
    return ApiService.fetchData({
        url: `/chats/${id}`,
        method: 'get',
    })
}

export async function apiGetChatMessages(chatId, params) {
    return ApiService.fetchData({
        url: `/chats/${chatId}/messages`,
        method: 'get',
        params,
    })
}

// Admin Chat API
export async function apiGetAllChatsForAdmin(params) {
    const mongoChats = await ApiService.fetchData({
        url: '/chats/admin/all',
        method: 'get',
        params,
    })

    // Get Firebase data for each chat
    const FirebaseService = (await import('./FirebaseService.js')).default
    const firebaseChats = await FirebaseService.getAllChats()

    // Merge MongoDB and Firebase data
    if (mongoChats?.data?.chats) {
        const mergedChats = mongoChats.data.chats.map(chat => {
            // Generate Firebase chat ID
            const participantIds = chat.participants?.map(p => p._id) || []
            const productId = chat.product?._id || ''

            if (participantIds.length >= 2 && productId) {
                const firebaseChatId = FirebaseService.generateChatId(participantIds, productId)
                const firebaseData = firebaseChats.find(fc => fc.id === firebaseChatId)

                return {
                    ...chat,
                    firebaseData,
                    firebaseChatId,
                    lastMessage: firebaseData?.lastMessage || 'No messages',
                    lastMessageTimestamp: firebaseData?.lastMessageTimestamp || chat.updatedAt,
                    messageCount: firebaseData?.messages ? Object.keys(firebaseData.messages).length : 0
                }
            }

            return chat
        })

        return {
            ...mongoChats,
            data: {
                ...mongoChats.data,
                chats: mergedChats
            }
        }
    }

    return mongoChats
}

export async function apiGetChatByIdForAdmin(id) {
    return ApiService.fetchData({
        url: `/chats/admin/${id}`,
        method: 'get',
    })
}



// ======================
// PAYMENT METHODS API
// ======================
export async function apiGetPaymentMethods(params) {
    return ApiService.fetchData({
        url: '/payment-methods',
        method: 'get',
        params,
    })
}

export async function apiGetPaymentMethodById(id) {
    return ApiService.fetchData({
        url: `/payment-methods/${id}`,
        method: 'get',
    })
}

export async function apiCreatePaymentMethod(data) {
    return ApiService.fetchData({
        url: '/payment-methods',
        method: 'post',
        data,
    })
}

export async function apiUpdatePaymentMethod(id, data) {
    return ApiService.fetchData({
        url: `/payment-methods/${id}`,
        method: 'put',
        data,
    })
}

export async function apiDeletePaymentMethod(id) {
    return ApiService.fetchData({
        url: `/payment-methods/${id}`,
        method: 'delete',
    })
}

// ======================
// NOTIFICATIONS API
// ======================
export async function apiGetNotifications(params) {
    return ApiService.fetchData({
        url: '/notifications',
        method: 'get',
        params,
    })
}

export async function apiGetNotificationById(id) {
    return ApiService.fetchData({
        url: `/notifications/${id}`,
        method: 'get',
    })
}

export async function apiCreateNotification(data) {
    return ApiService.fetchData({
        url: '/notifications',
        method: 'post',
        data,
    })
}

export async function apiUpdateNotification(id, data) {
    return ApiService.fetchData({
        url: `/notifications/${id}`,
        method: 'put',
        data,
    })
}

export async function apiDeleteNotification(id) {
    return ApiService.fetchData({
        url: `/notifications/${id}`,
        method: 'delete',
    })
}

// ======================
// DEVICE TOKENS API
// ======================
export async function apiGetDeviceTokens(params) {
    return ApiService.fetchData({
        url: '/device-tokens',
        method: 'get',
        params,
    })
}

export async function apiGetDeviceTokenById(id) {
    return ApiService.fetchData({
        url: `/device-tokens/${id}`,
        method: 'get',
    })
}

export async function apiCreateDeviceToken(data) {
    return ApiService.fetchData({
        url: '/device-tokens',
        method: 'post',
        data,
    })
}

export async function apiUpdateDeviceToken(id, data) {
    return ApiService.fetchData({
        url: `/device-tokens/${id}`,
        method: 'put',
        data,
    })
}

export async function apiDeleteDeviceToken(id) {
    return ApiService.fetchData({
        url: `/device-tokens/${id}`,
        method: 'delete',
    })
}

// ======================
// PRE-REGISTRATION API
// ======================
export async function apiGetPreRegistrations(params) {
    return ApiService.fetchData({
        url: '/pre-registration',
        method: 'get',
        params,
    })
}

export async function apiGetPreRegistrationById(id) {
    return ApiService.fetchData({
        url: `/pre-registration/${id}`,
        method: 'get',
    })
}

export async function apiCreatePreRegistration(data) {
    return ApiService.fetchData({
        url: '/pre-registration',
        method: 'post',
        data,
    })
}

export async function apiUpdatePreRegistration(id, data) {
    return ApiService.fetchData({
        url: `/pre-registration/${id}`,
        method: 'put',
        data,
    })
}

export async function apiDeletePreRegistration(id) {
    return ApiService.fetchData({
        url: `/pre-registration/${id}`,
        method: 'delete',
    })
}

// ======================
// USERS API
// ======================
export async function apiGetCustomersSummary() {
    return ApiService.fetchData({
        url: '/user/admin/customers-summary',
        method: 'get',
    })
}

export async function apiGetUsers(params, signal) {
    return ApiService.fetchData({
        url: '/user/admin/list',
        method: 'get',
        params,
        // AbortController signal from the directory's fetch effect — cancels
        // the in-flight request when filters change mid-flight.
        ...(signal ? { signal } : {}),
    })
}

export async function apiGetUserById(id) {
    return ApiService.fetchData({
        url: `/user/seller-profile/${id}`,
        method: 'get',
    })
}

export async function apiUpdateUser(id, data) {
    return ApiService.fetchData({
        url: `/user/profile/update`,
        method: 'put',
        data,
    })
}

export async function apiDeleteUser(id) {
    return ApiService.fetchData({
        url: `/user/deactivate`,
        method: 'post',
        data: { userId: id }
    })
}

// Get user profile by username
export async function apiGetUserProfile(username) {
    return ApiService.fetchData({
        url: `/user/seller/${username}/profile`,
        method: 'get',
    })
}

// Get user products
export async function apiGetUserProducts(username, params) {
    return ApiService.fetchData({
        url: `/user/seller/${username}/products`,
        method: 'get',
        params,
    })
}

// Follow/Unfollow user
export async function apiFollowUser(userId) {
    return ApiService.fetchData({
        url: '/user/follow',
        method: 'post',
        data: { userId }
    })
}

export async function apiUnfollowUser(userId) {
    return ApiService.fetchData({
        url: '/user/unfollow',
        method: 'post',
        data: { userId }
    })
}

// User feedback
export async function apiCreateUserFeedback(data) {
    return ApiService.fetchData({
        url: '/user/feedback/create',
        method: 'post',
        data,
    })
}

export async function apiGetUserFeedback(userId) {
    return ApiService.fetchData({
        url: '/user/feedback',
        method: 'get',
        params: { userId }
    })
}

export async function apiDeleteUserFeedback(userId) {
    return ApiService.fetchData({
        url: '/user/feedback/delete',
        method: 'delete',
        data: { userId }
    })
}

// ======================
// ADDRESSES API
// ======================
export async function apiGetAddresses(params) {
    return ApiService.fetchData({
        url: '/address',
        method: 'get',
        params,
    })
}

export async function apiGetAddressById(id) {
    return ApiService.fetchData({
        url: `/address/${id}`,
        method: 'get',
    })
}

export async function apiCreateAddress(data) {
    return ApiService.fetchData({
        url: '/address',
        method: 'post',
        data,
    })
}

export async function apiUpdateAddress(id, data) {
    return ApiService.fetchData({
        url: `/address/${id}`,
        method: 'put',
        data,
    })
}

export async function apiDeleteAddress(id) {
    return ApiService.fetchData({
        url: `/address/${id}`,
        method: 'delete',
    })
}

// ======================
// CART API
// ======================
export async function apiGetCarts(params) {
    return ApiService.fetchData({
        url: '/cart',
        method: 'get',
        params,
    })
}

export async function apiGetCartById(id) {
    return ApiService.fetchData({
        url: `/cart/${id}`,
        method: 'get',
    })
}

// ======================
// UPLOAD API
// ======================
export async function apiUploadProductImage(data) {
    return ApiService.fetchData({
        url: '/upload/single',
        method: 'post',
        data,
    })
}

export async function apiUploadMultipleFiles(data) {
    return ApiService.fetchData({
        url: '/upload/test-multiple',
        method: 'post',
        data,
    })
}

// ======================
// LEGACY SUPPORT (keeping existing functions for compatibility)
// ======================
export async function uploadProducts(data) {
    return ApiService.fetchData({
        url: '/admin/upload/uploadSingle',
        method: 'post',
        data,
    })
}


// ======================
// FILE UPLOAD API
// ======================
export async function apiUploadAvatar(data) {
    return ApiService.fetchData({
        url: '/upload/avatar',
        method: 'post',
        data,
    })
}

export async function apiUploadCover(data) {
    return ApiService.fetchData({
        url: '/upload/cover',
        method: 'post',
        data,
    })
}

export async function apiUploadProduct(data) {
    return ApiService.fetchData({
        url: '/upload/product',
        method: 'post',
        data,
    })
}


export async function apiUploadFile(data) {
    return ApiService.fetchData({
        url: '/upload',
        method: 'post',
        data,
    })
}

export async function apiUploadBanner(data) {
    return ApiService.fetchData({
        url: '/upload/banner',
        method: 'post',
        data,
    })
}

export async function apiUploadCategoryImage(data) {
    return ApiService.fetchData({
        url: '/upload/category',
        method: 'post',
        data,
    })
}

export async function apiUploadSubCategoryImage(data) {
    return ApiService.fetchData({
        url: '/upload/subcategory',
        method: 'post',
        data,
    })
}

export async function apiUploadBrandImage(data) {
    return ApiService.fetchData({
        url: '/upload/brand',
        method: 'post',
        data,
    })
}

// ======================
// TAXONOMY TYPES API
// ======================
export async function apiGetTaxonomyUsage() {
    return ApiService.fetchData({
        url: '/taxonomies/admin/usage',
        method: 'get',
    })
}

export async function apiGetTaxonomyTypes(params) {
    return ApiService.fetchData({
        url: '/taxonomies/types',
        method: 'get',
        params,
    })
}

export async function apiGetTaxonomyTypeById(slug) {
    return ApiService.fetchData({
        url: `/taxonomies/${slug}/detail`,
        method: 'get',
    })
}

export async function apiCreateTaxonomyType(data) {
    return ApiService.fetchData({
        url: '/taxonomies/create',
        method: 'post',
        data,
    })
}

export async function apiUpdateTaxonomyType(data) {
    return ApiService.fetchData({
        url: '/taxonomies/update',
        method: 'put',
        data,
    })
}

export async function apiDeleteTaxonomyType(data) {
    return ApiService.fetchData({
        url: '/taxonomies/delete',
        method: 'delete',
        data,
    })
}

export async function apiGetTaxonomiesByType(slug) {
    return ApiService.fetchData({
        url: `/taxonomies/${slug}/taxonomies`,
        method: 'get',
    })
}

// ======================
// DROPDOWN DATA APIs (Fetch all without pagination)
// ======================
export async function apiGetAllCategories() {
    return ApiService.fetchData({
        url: '/categories',
        method: 'get',
        params: {
            limit: 1000, // High limit to get all records
            page: 1,
            isActive: true // Only get active items
        },
    })
}

export async function apiGetAllSubCategories() {
    return ApiService.fetchData({
        url: '/sub-categories/admin/list',
        method: 'get',
        params: {
            limit: 1000, // High limit to get all records
            page: 1,
            activeSubCat: true // Only get active items
        },
    })
}

export async function apiGetAllBrands() {
    return ApiService.fetchData({
        url: '/brand/list',
        method: 'get',
        params: {
            limit: 1000, // High limit to get all records
            page: 1,
            isActive: true // Only get active items
        },
    })
}

export async function apiGetAllSellingTypes() {
    return ApiService.fetchData({
        url: '/selling-type/list',
        method: 'get',
        params: {
            limit: 1000, // High limit to get all records
            page: 1,
            isActive: true // Only get active items
        },
    })
}

// ======================
// ADMIN USER MANAGEMENT API
// ======================
export async function apiCreateAdminUser(data) {
    return ApiService.fetchData({
        url: `/user/admin/create`,
        method: 'post',
        data,
    })
}

export async function apiGetAdminUserById(id) {
    return ApiService.fetchData({
        url: `/user/admin/${id}`,
        method: 'get',
    })
}

export async function apiUpdateAdminUser(id, data) {
    return ApiService.fetchData({
        url: `/user/admin/${id}/update`,
        method: 'put',
        data,
    })
}

export async function apiToggleUserStatus(id) {
    return ApiService.fetchData({
        url: `/user/admin/${id}/toggle-status`,
        method: 'patch',
    })
}

export async function apiDeleteAdminUser(id) {
    return ApiService.fetchData({
        url: `/user/admin/${id}`,
        method: 'delete',
    })
}

// ======================
// GET APPROVED USERS FOR ADMIN SELECTION
// ======================
export async function apiGetApprovedUsers(params) {
    return ApiService.fetchData({
        url: '/user/admin/approved',
        method: 'get',
        params
    })
}

// ======================
// USER APPROVAL MANAGEMENT API
// ======================
export async function apiGetPendingUsers(params) {
    return ApiService.fetchData({
        url: '/user/admin/pending',
        method: 'get',
        params,
    })
}

export async function apiUpdateUserApprovalStatus(userId, data) {
    return ApiService.fetchData({
        url: `/user/admin/${userId}/approval`,
        method: 'patch',
        data,
    })
}

// ======================
// PRODUCT REVIEW MANAGEMENT API
// ======================
export async function apiGetPendingProducts(params) {
    return ApiService.fetchData({
        url: '/product/admin/pending',
        method: 'get',
        params,
    })
}

export async function apiReviewProduct(productId, data) {
    return ApiService.fetchData({
        url: `/product/admin/${productId}/review`,
        method: 'patch',
        data,
    })
}

export async function apiBulkApproveProducts(data) {
    return ApiService.fetchData({
        url: '/product/admin/bulk-approve',
        method: 'post',
        data,
    })
}

// ======================
// COUPONS API
// ======================
export async function apiGetSalesCoupon(params) {
    return ApiService.fetchData({
        url: '/coupons/list',
        method: 'get',
        params,
    })
}

export async function apiGetSalesCouponById(data) {
    return ApiService.fetchData({
        url: `/coupons/${data.id}`,
        method: 'get',
    })
}

export async function apiPutSalesCoupon(data) {
    return ApiService.fetchData({
        url: '/coupons/update',
        method: 'put',
        data,
    })
}

export async function apiCreateSalesCoupon(data) {
    return ApiService.fetchData({
        url: '/coupons/create',
        method: 'post',
        data,
    })
}

export async function apiDeleteSalesCoupon(data) {
    return ApiService.fetchData({
        url: '/coupons/delete',
        method: 'delete',
        data,
    })
}

export async function apiRestoreSalesCoupon(data) {
    return ApiService.fetchData({
        url: '/coupons/restore',
        method: 'post',
        data,
    })
}

export async function apiVerifyCoupon(data) {
    return ApiService.fetchData({
        url: '/coupons/verify',
        method: 'post',
        data,
    })
}

export async function apiApplyCoupon(data) {
    return ApiService.fetchData({
        url: '/coupons/apply',
        method: 'post',
        data,
    })
}

// ======================
// SHIPPING MANAGEMENT API
// ======================
export async function apiGetShippingOrders() {
    // scope=all -> admin sees every order in the shipping pipeline (not just their own).
    return ApiService.fetchData({
        url: '/orders?scope=all&limit=200&status=label_generated,dropped_off,in_transit_to_hub,at_hub,shipped_to_buyer',
        method: 'get',
    })
}

export async function apiUpdateShippingStatus(data) {
    return ApiService.fetchData({
        url: '/shipping/workflow/transit-status',
        method: 'put',
        data,
    })
}

// ======================
// PERSONAL SHOPPING API
// ======================
export async function apiGetPersonalShoppingRequests(params) {
    return ApiService.fetchData({
        url: '/personal-shopping/requests',
        method: 'get',
        params,
    })
}

export async function apiUpdatePersonalShoppingStatus(data) {
    return ApiService.fetchData({
        url: '/personal-shopping/update',
        method: 'put',
        data,
    })
}

// ======================
// SELLER APPLICATIONS API
// ======================
export async function apiGetSellerApplications(params) {
    return ApiService.fetchData({
        url: '/seller/admin/applications',
        method: 'get',
        params,
    })
}

export async function apiReviewSellerApplication(data) {
    return ApiService.fetchData({
        url: `/seller/admin/applications/${data.userId}/review`,
        method: 'patch',
        data,
    })
}

// ======================
// EXCHANGE REQUESTS API
// ======================
export async function apiGetExchangeRequests(params) {
    // Admin oversight: all requests, every status/requester (not the gated,
    // own-excluded, anonymized browse feed).
    return ApiService.fetchData({
        url: '/exchange/admin/requests',
        method: 'get',
        params,
    })
}

export async function apiGetApprovedSellers(params) {
    return ApiService.fetchData({
        url: '/seller/admin/sellers',
        method: 'get',
        params
    })
}

export async function apiRevokeSeller(userId, data) {
    return ApiService.fetchData({
        url: `/seller/admin/sellers/${userId}/revoke`,
        method: 'patch',
        data
    })
}

export async function apiGetActiveReservations() {
    return ApiService.fetchData({
        url: '/products/reservations/active',
        method: 'get',
    })
}

// ── Lookbooks — private clienteling selections ──
export async function apiGetLookbooks(params = {}) {
    return ApiService.fetchData({ url: '/lookbooks/admin', method: 'get', params })
}
export async function apiGetLookbook(id) {
    return ApiService.fetchData({ url: `/lookbooks/admin/${id}`, method: 'get' })
}
export async function apiCreateLookbook(data) {
    return ApiService.fetchData({ url: '/lookbooks/admin', method: 'post', data })
}
export async function apiUpdateLookbook(id, data) {
    return ApiService.fetchData({ url: `/lookbooks/admin/${id}`, method: 'put', data })
}

// Supplier payout ledger (admin audit P1-2)
export async function apiGetPayoutLedger() {
    return ApiService.fetchData({ url: '/orders/admin/payouts', method: 'get' })
}
